import { Injectable } from '@angular/core';
import { ILogger, LogLevel } from '@microsoft/signalr';
import { LoggingLevel } from '../config-service';
import { LoggerService } from '../logging/logger-service';

@Injectable({
  providedIn: 'root',
})
export class NotificationLogger implements ILogger {
  constructor(private loggerService: LoggerService) {}

  log(logLevel: LogLevel, message: string): void {
    const commonLogLevel = this.getCommonLogLevel(logLevel);
    this.loggerService.log(message, commonLogLevel, null);
  }

  getCommonLogLevel(logLevel: LogLevel): LoggingLevel {
    switch (logLevel) {
      case LogLevel.Trace:
        return LoggingLevel.Verbose;
      case LogLevel.Debug:
        return LoggingLevel.Verbose;
      case LogLevel.Information:
        return LoggingLevel.Info;
      case LogLevel.Warning:
        return LoggingLevel.Warnings;
      case LogLevel.Error:
        return LoggingLevel.Errors;
      case LogLevel.Critical:
        return LoggingLevel.Errors;
      case LogLevel.None:
        return LoggingLevel.None;
      default:
        throw new Error('Invalid Log Level');
    }
  }
}
